// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file asset/v1/asset.proto (package asset.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc, serviceDesc } from '@bufbuild/protobuf/codegenv2'
import { file_common_v1_annotations } from '../../common/v1/annotations_pb'
import type { PaginationArguments, PaginationPageInfo } from '../../common/v1/pagination_pb'
import { file_common_v1_pagination } from '../../common/v1/pagination_pb'
import { file_google_api_annotations } from '../../google/api/annotations_pb'
import type { Any, Timestamp } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_any, file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file asset/v1/asset.proto.
 */
export const file_asset_v1_asset: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_common_v1_annotations,
      file_common_v1_pagination,
      file_google_api_annotations,
      file_google_protobuf_any,
      file_google_protobuf_timestamp
    ]
  )

/**
 * @generated from message asset.v1.Asset
 */
export type Asset = Message<'asset.v1.Asset'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 14;
   */
  name: string

  /**
   * @generated from field: string description = 15;
   */
  description: string

  /**
   * @generated from field: string path = 2;
   */
  path: string

  /**
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string

  /**
   * @generated from field: string org_id = 4;
   */
  orgId: string

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId: string

  /**
   * @generated from field: string owner_id = 16;
   */
  ownerId: string

  /**
   * @generated from field: asset.v1.AssetType asset_type = 6;
   */
  assetType: AssetType

  /**
   * @generated from field: asset.v1.AssetState state = 7;
   */
  state: AssetState

  /**
   * @generated from field: string version = 22;
   */
  version: string

  /**
   * @generated from field: bool latest_version = 24;
   */
  latestVersion: boolean

  /**
   * @generated from field: asset.v1.CreationMethod creation_method = 8;
   */
  creationMethod: CreationMethod

  /**
   * @generated from field: google.protobuf.Any data = 9;
   */
  data?: Any

  /**
   * @generated from field: repeated string tags = 11;
   */
  tags: string[]

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 20;
   */
  archivedAt?: Timestamp

  /**
   * @generated from field: string opaque_id = 17;
   */
  opaqueId: string

  /**
   * @generated from field: asset.v1.Visibility visibility = 18;
   */
  visibility: Visibility

  /**
   * @generated from field: asset.v1.ArchiveReason archive_reason = 19;
   */
  archiveReason: ArchiveReason

  /**
   * @generated from field: string category = 21;
   */
  category: string

  /**
   * @generated from field: string container_id = 23;
   */
  containerId: string
}

/**
 * Describes the message asset.v1.Asset.
 * Use `create(AssetSchema)` to create a new message.
 */
export const AssetSchema: GenMessage<Asset> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 0)

/**
 * @generated from message asset.v1.DateRange
 */
export type DateRange = Message<'asset.v1.DateRange'> & {
  /**
   * Optional timestamp in RFC3339 format
   *
   * @generated from field: string start_date = 1;
   */
  startDate: string

  /**
   * optional timestamp in RFC3339 format
   *
   * @generated from field: string end_date = 2;
   */
  endDate: string
}

/**
 * Describes the message asset.v1.DateRange.
 * Use `create(DateRangeSchema)` to create a new message.
 */
export const DateRangeSchema: GenMessage<DateRange> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 1)

/**
 * If multiple filters are provided, they are combined together with the AND condition
 *
 * @generated from message asset.v1.AssetFilter
 */
export type AssetFilter = Message<'asset.v1.AssetFilter'> & {
  /**
   * returns assets only of the provides types
   *
   * @generated from field: repeated asset.v1.AssetType asset_types = 1;
   */
  assetTypes: AssetType[]

  /**
   * returns assets only in the provides states
   *
   * @generated from field: repeated asset.v1.AssetState states = 2;
   */
  states: AssetState[]

  /**
   * returns assets only in the provided creation method
   *
   * @generated from field: optional asset.v1.CreationMethod creation_method = 3;
   */
  creationMethod?: CreationMethod

  /**
   * returns only assets by the creator
   * Deprecated: Use creator_ids instead
   *
   * @generated from field: string creator_id = 4 [deprecated = true];
   * @deprecated
   */
  creatorId: string

  /**
   * returns assets that match the supplied name prefix
   *
   * @generated from field: string name_prefix = 5;
   */
  namePrefix: string

  /**
   * return assets that exactly match a string
   *
   * @generated from field: optional string exact_name = 16;
   */
  exactName?: string

  /**
   * returns assets associated with all of the supplied tags
   *
   * @generated from field: repeated string tags = 6;
   */
  tags: string[]

  /**
   * CreatedAtDateRange scopes the response to assets created in the specified range. The filter is exclusive
   *
   * When start_date is empty the filtering will get everything created up to end_date
   * When end_date is empty the filtering will get everything created from the start_date up until now
   *
   * @generated from field: optional asset.v1.DateRange created_at_date_range = 7;
   */
  createdAtDateRange?: DateRange

  /**
   * returns only assets by the owner
   *
   * @generated from field: repeated string owner_ids = 8;
   */
  ownerIds: string[]

  /**
   * @generated from field: string opaque_id = 9;
   */
  opaqueId: string

  /**
   * returns assets that match any of the supplied set of visibilities
   *
   * @generated from field: repeated asset.v1.Visibility visibilities = 11;
   */
  visibilities: Visibility[]

  /**
   * returns assets that match any of the supplied set of asset categories
   *
   * @generated from field: repeated string categories = 12;
   */
  categories: string[]

  /**
   * @generated from field: optional asset.v1.Location location = 13;
   */
  location?: Location

  /**
   * returns assets that match any of the supplied set of creator ids
   *
   * @generated from field: repeated string creator_ids = 14;
   */
  creatorIds: string[]

  /**
   * @generated from field: optional string path = 15;
   */
  path?: string
}

/**
 * Describes the message asset.v1.AssetFilter.
 * Use `create(AssetFilterSchema)` to create a new message.
 */
export const AssetFilterSchema: GenMessage<AssetFilter> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 2)

/**
 * @generated from message asset.v1.UpdateAssetRequest
 */
export type UpdateAssetRequest = Message<'asset.v1.UpdateAssetRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 10;
   */
  version: string

  /**
   * @generated from field: optional string path = 2 [deprecated = true];
   * @deprecated
   */
  path?: string

  /**
   * optional tags needed as we migrate tagging into the assets-service
   * updating an assets tag will hit the assets-service mutations after migrations
   *
   * @generated from field: repeated string tags = 3;
   */
  tags: string[]

  /**
   * optional data to store with this asset
   *
   * @generated from field: google.protobuf.Any data = 4;
   */
  data?: Any

  /**
   * Name is an optional display name associated to the asset.
   *
   * @generated from field: optional string name = 5;
   */
  name?: string

  /**
   * Description is an optional description associated to the asset.
   *
   * @generated from field: optional string description = 6;
   */
  description?: string

  /**
   * OwnerId is an optional field used to "transfer ownership" of an asset
   *
   * @generated from field: optional string owner_id = 7;
   */
  ownerId?: string

  /**
   * @generated from field: asset.v1.Visibility visibility = 8;
   */
  visibility: Visibility

  /**
   * @generated from field: optional string category = 9;
   */
  category?: string
}

/**
 * Describes the message asset.v1.UpdateAssetRequest.
 * Use `create(UpdateAssetRequestSchema)` to create a new message.
 */
export const UpdateAssetRequestSchema: GenMessage<UpdateAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 3)

/**
 * @generated from message asset.v1.UpdateAssetsRequest
 */
export type UpdateAssetsRequest = Message<'asset.v1.UpdateAssetsRequest'> & {
  /**
   * @generated from field: repeated asset.v1.UpdateAssetRequest assets = 1;
   */
  assets: UpdateAssetRequest[]
}

/**
 * Describes the message asset.v1.UpdateAssetsRequest.
 * Use `create(UpdateAssetsRequestSchema)` to create a new message.
 */
export const UpdateAssetsRequestSchema: GenMessage<UpdateAssetsRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 4)

/**
 * ArchiveAssetRequest updates the state of the asset to archived
 *
 * @generated from message asset.v1.ArchiveAssetsRequest
 */
export type ArchiveAssetsRequest = Message<'asset.v1.ArchiveAssetsRequest'> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[]

  /**
   * @generated from field: optional asset.v1.ArchiveReason archive_reason = 2;
   */
  archiveReason?: ArchiveReason
}

/**
 * Describes the message asset.v1.ArchiveAssetsRequest.
 * Use `create(ArchiveAssetsRequestSchema)` to create a new message.
 */
export const ArchiveAssetsRequestSchema: GenMessage<ArchiveAssetsRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 5)

/**
 * @generated from message asset.v1.ArchiveAssetRequest
 */
export type ArchiveAssetRequest = Message<'asset.v1.ArchiveAssetRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: optional asset.v1.ArchiveReason archive_reason = 2;
   */
  archiveReason?: ArchiveReason
}

/**
 * Describes the message asset.v1.ArchiveAssetRequest.
 * Use `create(ArchiveAssetRequestSchema)` to create a new message.
 */
export const ArchiveAssetRequestSchema: GenMessage<ArchiveAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 6)

/**
 * @generated from message asset.v1.RestoreAssetRequest
 */
export type RestoreAssetRequest = Message<'asset.v1.RestoreAssetRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message asset.v1.RestoreAssetRequest.
 * Use `create(RestoreAssetRequestSchema)` to create a new message.
 */
export const RestoreAssetRequestSchema: GenMessage<RestoreAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 7)

/**
 * @generated from message asset.v1.RestoreAssetsRequest
 */
export type RestoreAssetsRequest = Message<'asset.v1.RestoreAssetsRequest'> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[]
}

/**
 * Describes the message asset.v1.RestoreAssetsRequest.
 * Use `create(RestoreAssetsRequestSchema)` to create a new message.
 */
export const RestoreAssetsRequestSchema: GenMessage<RestoreAssetsRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 8)

/**
 * @generated from message asset.v1.DeleteAssetRequest
 */
export type DeleteAssetRequest = Message<'asset.v1.DeleteAssetRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2;
   */
  version: string
}

/**
 * Describes the message asset.v1.DeleteAssetRequest.
 * Use `create(DeleteAssetRequestSchema)` to create a new message.
 */
export const DeleteAssetRequestSchema: GenMessage<DeleteAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 9)

/**
 * @generated from message asset.v1.DeleteAssetsRequest
 */
export type DeleteAssetsRequest = Message<'asset.v1.DeleteAssetsRequest'> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[]
}

/**
 * Describes the message asset.v1.DeleteAssetsRequest.
 * Use `create(DeleteAssetsRequestSchema)` to create a new message.
 */
export const DeleteAssetsRequestSchema: GenMessage<DeleteAssetsRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 10)

/**
 * @generated from message asset.v1.GetAssetRequest
 */
export type GetAssetRequest = Message<'asset.v1.GetAssetRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2;
   */
  version: string
}

/**
 * Describes the message asset.v1.GetAssetRequest.
 * Use `create(GetAssetRequestSchema)` to create a new message.
 */
export const GetAssetRequestSchema: GenMessage<GetAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 11)

/**
 * @generated from message asset.v1.GetAssetsRequest
 */
export type GetAssetsRequest = Message<'asset.v1.GetAssetsRequest'> & {
  /**
   * @(metabase) Implicitly gets most recent version
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[]

  /**
   * @generated from field: repeated asset.v1.GetAssetRequest requests = 2;
   */
  requests: GetAssetRequest[]
}

/**
 * Describes the message asset.v1.GetAssetsRequest.
 * Use `create(GetAssetsRequestSchema)` to create a new message.
 */
export const GetAssetsRequestSchema: GenMessage<GetAssetsRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 12)

/**
 * @generated from message asset.v1.OrgAndWorkspace
 */
export type OrgAndWorkspace = Message<'asset.v1.OrgAndWorkspace'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string
}

/**
 * Describes the message asset.v1.OrgAndWorkspace.
 * Use `create(OrgAndWorkspaceSchema)` to create a new message.
 */
export const OrgAndWorkspaceSchema: GenMessage<OrgAndWorkspace> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 13)

/**
 * @generated from message asset.v1.ListAssetsRequest
 */
export type ListAssetsRequest = Message<'asset.v1.ListAssetsRequest'> & {
  /**
   * @generated from oneof asset.v1.ListAssetsRequest.id
   */
  id:
    | {
        /**
         * @generated from field: string org_id = 1;
         */
        value: string
        case: 'orgId'
      }
    | {
        /**
         * @generated from field: string workspace_id = 2;
         */
        value: string
        case: 'workspaceId'
      }
    | {
        /**
         * @generated from field: string folder_id = 3;
         */
        value: string
        case: 'folderId'
      }
    | {
        /**
         * @generated from field: asset.v1.OrgAndWorkspace org_and_workspace = 6;
         */
        value: OrgAndWorkspace
        case: 'orgAndWorkspace'
      }
    | { case: undefined; value?: undefined }

  /**
   * @generated from field: asset.v1.AssetFilter filter = 4;
   */
  filter?: AssetFilter

  /**
   * @generated from field: optional common.v1.PaginationArguments paginate = 5;
   */
  paginate?: PaginationArguments
}

/**
 * Describes the message asset.v1.ListAssetsRequest.
 * Use `create(ListAssetsRequestSchema)` to create a new message.
 */
export const ListAssetsRequestSchema: GenMessage<ListAssetsRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 14)

/**
 * @generated from message asset.v1.CountAssetsRequest
 */
export type CountAssetsRequest = Message<'asset.v1.CountAssetsRequest'> & {
  /**
   * @generated from oneof asset.v1.CountAssetsRequest.id
   */
  id:
    | {
        /**
         * @generated from field: string org_id = 1;
         */
        value: string
        case: 'orgId'
      }
    | {
        /**
         * @generated from field: string workspace_id = 2;
         */
        value: string
        case: 'workspaceId'
      }
    | {
        /**
         * @generated from field: string folder_id = 3;
         */
        value: string
        case: 'folderId'
      }
    | { case: undefined; value?: undefined }

  /**
   * @generated from field: asset.v1.AssetFilter filter = 4;
   */
  filter?: AssetFilter
}

/**
 * Describes the message asset.v1.CountAssetsRequest.
 * Use `create(CountAssetsRequestSchema)` to create a new message.
 */
export const CountAssetsRequestSchema: GenMessage<CountAssetsRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 15)

/**
 * @generated from message asset.v1.Destination
 */
export type Destination = Message<'asset.v1.Destination'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string

  /**
   * @generated from field: string path = 3;
   */
  path: string
}

/**
 * Describes the message asset.v1.Destination.
 * Use `create(DestinationSchema)` to create a new message.
 */
export const DestinationSchema: GenMessage<Destination> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 16)

/**
 * @generated from message asset.v1.MoveAssetsRequest
 */
export type MoveAssetsRequest = Message<'asset.v1.MoveAssetsRequest'> & {
  /**
   * @generated from field: repeated string asset_ids = 1;
   */
  assetIds: string[]

  /**
   * @generated from oneof asset.v1.MoveAssetsRequest.id
   */
  id:
    | {
        /**
         * @generated from field: string org_id = 2;
         */
        value: string
        case: 'orgId'
      }
    | {
        /**
         * @generated from field: string workspace_id = 3;
         */
        value: string
        case: 'workspaceId'
      }
    | {
        /**
         * field deprecated in f2
         *
         * @generated from field: string folder_id = 4 [deprecated = true];
         * @deprecated
         */
        value: string
        case: 'folderId'
      }
    | { case: undefined; value?: undefined }

  /**
   * used in f2
   *
   * @generated from field: asset.v1.Destination destination = 5;
   */
  destination?: Destination
}

/**
 * Describes the message asset.v1.MoveAssetsRequest.
 * Use `create(MoveAssetsRequestSchema)` to create a new message.
 */
export const MoveAssetsRequestSchema: GenMessage<MoveAssetsRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 17)

/**
 * @generated from message asset.v1.EmptyArchiveRequest
 */
export type EmptyArchiveRequest = Message<'asset.v1.EmptyArchiveRequest'> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string
}

/**
 * Describes the message asset.v1.EmptyArchiveRequest.
 * Use `create(EmptyArchiveRequestSchema)` to create a new message.
 */
export const EmptyArchiveRequestSchema: GenMessage<EmptyArchiveRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 18)

/**
 * @generated from message asset.v1.UpdateAssetResponse
 */
export type UpdateAssetResponse = Message<'asset.v1.UpdateAssetResponse'> & {
  /**
   * @generated from field: asset.v1.Asset asset = 1;
   */
  asset?: Asset
}

/**
 * Describes the message asset.v1.UpdateAssetResponse.
 * Use `create(UpdateAssetResponseSchema)` to create a new message.
 */
export const UpdateAssetResponseSchema: GenMessage<UpdateAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 19)

/**
 * @generated from message asset.v1.UpdateAssetsResponse
 */
export type UpdateAssetsResponse = Message<'asset.v1.UpdateAssetsResponse'> & {
  /**
   * @generated from field: repeated asset.v1.Asset assets = 1;
   */
  assets: Asset[]
}

/**
 * Describes the message asset.v1.UpdateAssetsResponse.
 * Use `create(UpdateAssetsResponseSchema)` to create a new message.
 */
export const UpdateAssetsResponseSchema: GenMessage<UpdateAssetsResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 20)

/**
 * @generated from message asset.v1.ArchiveAssetsResponse
 */
export type ArchiveAssetsResponse = Message<'asset.v1.ArchiveAssetsResponse'> & {
  /**
   * @generated from field: repeated asset.v1.Asset assets = 1;
   */
  assets: Asset[]
}

/**
 * Describes the message asset.v1.ArchiveAssetsResponse.
 * Use `create(ArchiveAssetsResponseSchema)` to create a new message.
 */
export const ArchiveAssetsResponseSchema: GenMessage<ArchiveAssetsResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 21)

/**
 * @generated from message asset.v1.ArchiveAssetResponse
 */
export type ArchiveAssetResponse = Message<'asset.v1.ArchiveAssetResponse'> & {
  /**
   * @generated from field: asset.v1.Asset asset = 1;
   */
  asset?: Asset
}

/**
 * Describes the message asset.v1.ArchiveAssetResponse.
 * Use `create(ArchiveAssetResponseSchema)` to create a new message.
 */
export const ArchiveAssetResponseSchema: GenMessage<ArchiveAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 22)

/**
 * @generated from message asset.v1.RestoreAssetResponse
 */
export type RestoreAssetResponse = Message<'asset.v1.RestoreAssetResponse'> & {
  /**
   * @generated from field: asset.v1.Asset asset = 1;
   */
  asset?: Asset
}

/**
 * Describes the message asset.v1.RestoreAssetResponse.
 * Use `create(RestoreAssetResponseSchema)` to create a new message.
 */
export const RestoreAssetResponseSchema: GenMessage<RestoreAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 23)

/**
 * @generated from message asset.v1.RestoreAssetsResponse
 */
export type RestoreAssetsResponse = Message<'asset.v1.RestoreAssetsResponse'> & {
  /**
   * @generated from field: repeated asset.v1.Asset assets = 1;
   */
  assets: Asset[]
}

/**
 * Describes the message asset.v1.RestoreAssetsResponse.
 * Use `create(RestoreAssetsResponseSchema)` to create a new message.
 */
export const RestoreAssetsResponseSchema: GenMessage<RestoreAssetsResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 24)

/**
 * @generated from message asset.v1.DeleteAssetResponse
 */
export type DeleteAssetResponse = Message<'asset.v1.DeleteAssetResponse'> & {}

/**
 * Describes the message asset.v1.DeleteAssetResponse.
 * Use `create(DeleteAssetResponseSchema)` to create a new message.
 */
export const DeleteAssetResponseSchema: GenMessage<DeleteAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 25)

/**
 * @generated from message asset.v1.DeleteAssetsResponse
 */
export type DeleteAssetsResponse = Message<'asset.v1.DeleteAssetsResponse'> & {}

/**
 * Describes the message asset.v1.DeleteAssetsResponse.
 * Use `create(DeleteAssetsResponseSchema)` to create a new message.
 */
export const DeleteAssetsResponseSchema: GenMessage<DeleteAssetsResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 26)

/**
 * @generated from message asset.v1.GetAssetResponse
 */
export type GetAssetResponse = Message<'asset.v1.GetAssetResponse'> & {
  /**
   * @generated from field: asset.v1.Asset asset = 1;
   */
  asset?: Asset
}

/**
 * Describes the message asset.v1.GetAssetResponse.
 * Use `create(GetAssetResponseSchema)` to create a new message.
 */
export const GetAssetResponseSchema: GenMessage<GetAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 27)

/**
 * @generated from message asset.v1.GetAssetsResponse
 */
export type GetAssetsResponse = Message<'asset.v1.GetAssetsResponse'> & {
  /**
   * @generated from field: repeated asset.v1.Asset assets = 1;
   */
  assets: Asset[]
}

/**
 * Describes the message asset.v1.GetAssetsResponse.
 * Use `create(GetAssetsResponseSchema)` to create a new message.
 */
export const GetAssetsResponseSchema: GenMessage<GetAssetsResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 28)

/**
 * @generated from message asset.v1.ListVersionsRequest
 */
export type ListVersionsRequest = Message<'asset.v1.ListVersionsRequest'> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string

  /**
   * @generated from field: optional common.v1.PaginationArguments paginate = 4;
   */
  paginate?: PaginationArguments

  /**
   * @generated from field: optional asset.v1.AssetState state = 5;
   */
  state?: AssetState
}

/**
 * Describes the message asset.v1.ListVersionsRequest.
 * Use `create(ListVersionsRequestSchema)` to create a new message.
 */
export const ListVersionsRequestSchema: GenMessage<ListVersionsRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 29)

/**
 * @generated from message asset.v1.ListVersionsResponse
 */
export type ListVersionsResponse = Message<'asset.v1.ListVersionsResponse'> & {
  /**
   * @generated from field: repeated asset.v1.Asset assets = 1;
   */
  assets: Asset[]

  /**
   * @generated from field: common.v1.PaginationPageInfo page_info = 2;
   */
  pageInfo?: PaginationPageInfo
}

/**
 * Describes the message asset.v1.ListVersionsResponse.
 * Use `create(ListVersionsResponseSchema)` to create a new message.
 */
export const ListVersionsResponseSchema: GenMessage<ListVersionsResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 30)

/**
 * @generated from message asset.v1.CreateVersionRequest
 */
export type CreateVersionRequest = Message<'asset.v1.CreateVersionRequest'> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string

  /**
   * deprecated, use increments
   *
   * @generated from field: string version = 2 [deprecated = true];
   * @deprecated
   */
  version: string

  /**
   * @generated from field: asset.v1.VersionIncrement increment = 4;
   */
  increment: VersionIncrement

  /**
   * if set, specifies version to clone into a new one, otherwise uses most recent version
   *
   * @generated from field: string base_version = 3;
   */
  baseVersion: string
}

/**
 * Describes the message asset.v1.CreateVersionRequest.
 * Use `create(CreateVersionRequestSchema)` to create a new message.
 */
export const CreateVersionRequestSchema: GenMessage<CreateVersionRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 31)

/**
 * @generated from message asset.v1.CreateVersionResponse
 */
export type CreateVersionResponse = Message<'asset.v1.CreateVersionResponse'> & {
  /**
   * @generated from field: asset.v1.Asset asset = 1;
   */
  asset?: Asset
}

/**
 * Describes the message asset.v1.CreateVersionResponse.
 * Use `create(CreateVersionResponseSchema)` to create a new message.
 */
export const CreateVersionResponseSchema: GenMessage<CreateVersionResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 32)

/**
 * @generated from message asset.v1.PublishVersionRequest
 */
export type PublishVersionRequest = Message<'asset.v1.PublishVersionRequest'> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string

  /**
   * @generated from field: string version = 2;
   */
  version: string

  /**
   * @generated from field: asset.v1.Visibility visibility = 3;
   */
  visibility: Visibility
}

/**
 * Describes the message asset.v1.PublishVersionRequest.
 * Use `create(PublishVersionRequestSchema)` to create a new message.
 */
export const PublishVersionRequestSchema: GenMessage<PublishVersionRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 33)

/**
 * @generated from message asset.v1.PublishVersionResponse
 */
export type PublishVersionResponse = Message<'asset.v1.PublishVersionResponse'> & {
  /**
   * @generated from field: asset.v1.Asset asset = 1;
   */
  asset?: Asset
}

/**
 * Describes the message asset.v1.PublishVersionResponse.
 * Use `create(PublishVersionResponseSchema)` to create a new message.
 */
export const PublishVersionResponseSchema: GenMessage<PublishVersionResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 34)

/**
 * @generated from message asset.v1.GetAssetCategoriesRequest
 */
export type GetAssetCategoriesRequest = Message<'asset.v1.GetAssetCategoriesRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string

  /**
   * @generated from field: asset.v1.AssetFilter filter = 3;
   */
  filter?: AssetFilter
}

/**
 * Describes the message asset.v1.GetAssetCategoriesRequest.
 * Use `create(GetAssetCategoriesRequestSchema)` to create a new message.
 */
export const GetAssetCategoriesRequestSchema: GenMessage<GetAssetCategoriesRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 35)

/**
 * @generated from message asset.v1.GetAssetCategoriesResponse
 */
export type GetAssetCategoriesResponse = Message<'asset.v1.GetAssetCategoriesResponse'> & {
  /**
   * @generated from field: repeated asset.v1.Category categories = 1;
   */
  categories: Category[]
}

/**
 * Describes the message asset.v1.GetAssetCategoriesResponse.
 * Use `create(GetAssetCategoriesResponseSchema)` to create a new message.
 */
export const GetAssetCategoriesResponseSchema: GenMessage<GetAssetCategoriesResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 36)

/**
 * @generated from message asset.v1.Category
 */
export type Category = Message<'asset.v1.Category'> & {
  /**
   * @generated from field: string category = 1;
   */
  category: string

  /**
   * @generated from field: int64 count = 2;
   */
  count: bigint
}

/**
 * Describes the message asset.v1.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema: GenMessage<Category> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 37)

/**
 * @generated from message asset.v1.ListAssetsResponse
 */
export type ListAssetsResponse = Message<'asset.v1.ListAssetsResponse'> & {
  /**
   * @generated from field: repeated asset.v1.Asset assets = 1;
   */
  assets: Asset[]

  /**
   * @generated from field: common.v1.PaginationPageInfo page_info = 2;
   */
  pageInfo?: PaginationPageInfo
}

/**
 * Describes the message asset.v1.ListAssetsResponse.
 * Use `create(ListAssetsResponseSchema)` to create a new message.
 */
export const ListAssetsResponseSchema: GenMessage<ListAssetsResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 38)

/**
 * @generated from message asset.v1.CountAssetsResponse
 */
export type CountAssetsResponse = Message<'asset.v1.CountAssetsResponse'> & {
  /**
   * @generated from field: int32 num_assets = 1;
   */
  numAssets: number
}

/**
 * Describes the message asset.v1.CountAssetsResponse.
 * Use `create(CountAssetsResponseSchema)` to create a new message.
 */
export const CountAssetsResponseSchema: GenMessage<CountAssetsResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 39)

/**
 * @generated from message asset.v1.MoveAssetsResponse
 */
export type MoveAssetsResponse = Message<'asset.v1.MoveAssetsResponse'> & {
  /**
   * @generated from field: repeated asset.v1.Asset assets = 1;
   */
  assets: Asset[]
}

/**
 * Describes the message asset.v1.MoveAssetsResponse.
 * Use `create(MoveAssetsResponseSchema)` to create a new message.
 */
export const MoveAssetsResponseSchema: GenMessage<MoveAssetsResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 40)

/**
 * @generated from message asset.v1.EmptyArchiveResponse
 */
export type EmptyArchiveResponse = Message<'asset.v1.EmptyArchiveResponse'> & {}

/**
 * Describes the message asset.v1.EmptyArchiveResponse.
 * Use `create(EmptyArchiveResponseSchema)` to create a new message.
 */
export const EmptyArchiveResponseSchema: GenMessage<EmptyArchiveResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 41)

/**
 * @generated from message asset.v1.GetDefaultAssetRequest
 */
export type GetDefaultAssetRequest = Message<'asset.v1.GetDefaultAssetRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: optional string workspace_id = 2;
   */
  workspaceId?: string

  /**
   * @generated from field: asset.v1.AssetType asset_type = 3;
   */
  assetType: AssetType
}

/**
 * Describes the message asset.v1.GetDefaultAssetRequest.
 * Use `create(GetDefaultAssetRequestSchema)` to create a new message.
 */
export const GetDefaultAssetRequestSchema: GenMessage<GetDefaultAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 42)

/**
 * @generated from message asset.v1.GetDefaultAssetResponse
 */
export type GetDefaultAssetResponse = Message<'asset.v1.GetDefaultAssetResponse'> & {
  /**
   * @generated from field: asset.v1.Asset asset = 1;
   */
  asset?: Asset
}

/**
 * Describes the message asset.v1.GetDefaultAssetResponse.
 * Use `create(GetDefaultAssetResponseSchema)` to create a new message.
 */
export const GetDefaultAssetResponseSchema: GenMessage<GetDefaultAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 43)

/**
 * @generated from message asset.v1.SetDefaultAssetRequest
 */
export type SetDefaultAssetRequest = Message<'asset.v1.SetDefaultAssetRequest'> & {
  /**
   * @generated from field: optional string asset_id = 1;
   */
  assetId?: string

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string

  /**
   * @generated from field: optional string workspace_id = 3;
   */
  workspaceId?: string

  /**
   * @generated from field: asset.v1.AssetType asset_type = 4;
   */
  assetType: AssetType
}

/**
 * Describes the message asset.v1.SetDefaultAssetRequest.
 * Use `create(SetDefaultAssetRequestSchema)` to create a new message.
 */
export const SetDefaultAssetRequestSchema: GenMessage<SetDefaultAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 44)

/**
 * @generated from message asset.v1.SetDefaultAssetResponse
 */
export type SetDefaultAssetResponse = Message<'asset.v1.SetDefaultAssetResponse'> & {}

/**
 * Describes the message asset.v1.SetDefaultAssetResponse.
 * Use `create(SetDefaultAssetResponseSchema)` to create a new message.
 */
export const SetDefaultAssetResponseSchema: GenMessage<SetDefaultAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_asset_v1_asset, 45)

/**
 * @generated from enum asset.v1.AssetState
 */
export enum AssetState {
  /**
   * @generated from enum value: ASSET_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_STATE_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: ASSET_STATE_DRAFT = 2;
   */
  DRAFT = 2,

  /**
   * @generated from enum value: ASSET_STATE_ARCHIVED = 3;
   */
  ARCHIVED = 3
}

/**
 * Describes the enum asset.v1.AssetState.
 */
export const AssetStateSchema: GenEnum<AssetState> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 0)

/**
 * @generated from enum asset.v1.AssetType
 */
export enum AssetType {
  /**
   * @generated from enum value: ASSET_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_TYPE_CODE = 1;
   */
  CODE = 1,

  /**
   * @generated from enum value: ASSET_TYPE_PAGE = 2;
   */
  PAGE = 2,

  /**
   * @generated from enum value: ASSET_TYPE_PAGE_V2 = 3;
   */
  PAGE_V2 = 3,

  /**
   * @generated from enum value: ASSET_TYPE_PAGE_TEMPLATE_V2 = 4;
   */
  PAGE_TEMPLATE_V2 = 4,

  /**
   * @generated from enum value: ASSET_TYPE_BUNDLE = 5;
   */
  BUNDLE = 5,

  /**
   * @generated from enum value: ASSET_TYPE_SUITE = 6;
   */
  SUITE = 6,

  /**
   * @generated from enum value: ASSET_TYPE_BRAND_KIT = 7;
   */
  BRAND_KIT = 7,

  /**
   * @generated from enum value: ASSET_TYPE_STUDIO_CONFIG = 8;
   */
  STUDIO_CONFIG = 8,

  /**
   * @generated from enum value: ASSET_TYPE_CODE_V3 = 9;
   */
  CODE_V3 = 9,

  /**
   * @generated from enum value: ASSET_TYPE_BATCH = 10;
   */
  BATCH = 10,

  /**
   * @generated from enum value: ASSET_TYPE_BATCH_TEMPLATE = 11;
   */
  BATCH_TEMPLATE = 11,

  /**
   * @generated from enum value: ASSET_TYPE_WALLET_PASS_BATCH = 12;
   */
  WALLET_PASS_BATCH = 12,

  /**
   * @generated from enum value: ASSET_TYPE_WALLET_PASS_TEMPLATE = 13;
   */
  WALLET_PASS_TEMPLATE = 13,

  /**
   * @generated from enum value: ASSET_TYPE_WALLET_PASS = 14;
   */
  WALLET_PASS = 14,

  /**
   * @generated from enum value: ASSET_TYPE_SHORT_URL = 15;
   */
  SHORT_URL = 15,

  /**
   * @generated from enum value: ASSET_TYPE_MODULE_TEMPLATE = 17;
   */
  MODULE_TEMPLATE = 17,

  /**
   * @generated from enum value: ASSET_TYPE_MODULE = 18;
   */
  MODULE = 18,

  /**
   * @generated from enum value: ASSET_TYPE_ENTRYPOINT_BATCH = 19;
   */
  ENTRYPOINT_BATCH = 19,

  /**
   * @generated from enum value: ASSET_TYPE_ENTRYPOINT_BATCH_TEMPLATE = 20;
   */
  ENTRYPOINT_BATCH_TEMPLATE = 20,

  /**
   * @generated from enum value: ASSET_TYPE_CONTACT_SCHEMA = 21 [deprecated = true];
   * @deprecated
   */
  CONTACT_SCHEMA = 21,

  /**
   * @generated from enum value: ASSET_TYPE_STATIC_ASSET = 22;
   */
  STATIC_ASSET = 22,

  /**
   * @generated from enum value: ASSET_TYPE_FORM = 23;
   */
  FORM = 23,

  /**
   * @generated from enum value: ASSET_TYPE_TERMS_AND_CONDITIONS = 24;
   */
  TERMS_AND_CONDITIONS = 24
}

/**
 * Describes the enum asset.v1.AssetType.
 */
export const AssetTypeSchema: GenEnum<AssetType> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 1)

/**
 * @generated from enum asset.v1.CreationMethod
 */
export enum CreationMethod {
  /**
   * @generated from enum value: CREATION_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CREATION_METHOD_PLATFORM = 1;
   */
  PLATFORM = 1,

  /**
   * @generated from enum value: CREATION_METHOD_API = 2;
   */
  API = 2
}

/**
 * Describes the enum asset.v1.CreationMethod.
 */
export const CreationMethodSchema: GenEnum<CreationMethod> =
  /*@__PURE__*/
  enumDesc(file_asset_v1_asset, 2)

/**
 * @generated from enum asset.v1.ArchiveReason
 */
export enum ArchiveReason {
  /**
   * @generated from enum value: ARCHIVE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ARCHIVE_REASON_USER_ARCHIVAL = 1;
   */
  USER_ARCHIVAL = 1,

  /**
   * @generated from enum value: ARCHIVE_REASON_SUBSCRIPTION_CANCELLED = 2;
   */
  SUBSCRIPTION_CANCELLED = 2,

  /**
   * @generated from enum value: ARCHIVE_REASON_CONTENT_MODERATION = 3;
   */
  CONTENT_MODERATION = 3,

  /**
   * @generated from enum value: ARCHIVE_REASON_ML_MODERATION = 4;
   */
  ML_MODERATION = 4,

  /**
   * @generated from enum value: ARCHIVE_REASON_FOLDER_ARCHIVED = 5;
   */
  FOLDER_ARCHIVED = 5,

  /**
   * @generated from enum value: ARCHIVE_REASON_PARENT_ARCHIVED = 6;
   */
  PARENT_ARCHIVED = 6
}

/**
 * Describes the enum asset.v1.ArchiveReason.
 */
export const ArchiveReasonSchema: GenEnum<ArchiveReason> =
  /*@__PURE__*/
  enumDesc(file_asset_v1_asset, 3)

/**
 * @generated from enum asset.v1.Visibility
 */
export enum Visibility {
  /**
   * @generated from enum value: VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VISIBILITY_PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * @generated from enum value: VISIBILITY_PUBLIC = 2;
   */
  PUBLIC = 2,

  /**
   * @generated from enum value: VISIBILITY_ORG = 3;
   */
  ORG = 3
}

/**
 * Describes the enum asset.v1.Visibility.
 */
export const VisibilitySchema: GenEnum<Visibility> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 4)

/**
 * @generated from enum asset.v1.Location
 */
export enum Location {
  /**
   * @generated from enum value: LOCATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOCATION_ROOT = 1;
   */
  ROOT = 1,

  /**
   * @generated from enum value: LOCATION_FOLDER = 2;
   */
  FOLDER = 2
}

/**
 * Describes the enum asset.v1.Location.
 */
export const LocationSchema: GenEnum<Location> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 5)

/**
 * @generated from enum asset.v1.VersionIncrement
 */
export enum VersionIncrement {
  /**
   * @generated from enum value: VERSION_INCREMENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VERSION_INCREMENT_MAJOR = 1;
   */
  MAJOR = 1,

  /**
   * @generated from enum value: VERSION_INCREMENT_MINOR = 2;
   */
  MINOR = 2,

  /**
   * @generated from enum value: VERSION_INCREMENT_PATCH = 3;
   */
  PATCH = 3
}

/**
 * Describes the enum asset.v1.VersionIncrement.
 */
export const VersionIncrementSchema: GenEnum<VersionIncrement> =
  /*@__PURE__*/
  enumDesc(file_asset_v1_asset, 6)

/**
 * @generated from service asset.v1.AssetService
 */
export const AssetService: GenService<{
  /**
   * Defaults
   *
   * @generated from rpc asset.v1.AssetService.GetDefaultAsset
   */
  getDefaultAsset: {
    methodKind: 'unary'
    input: typeof GetDefaultAssetRequestSchema
    output: typeof GetDefaultAssetResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.SetDefaultAsset
   */
  setDefaultAsset: {
    methodKind: 'unary'
    input: typeof SetDefaultAssetRequestSchema
    output: typeof SetDefaultAssetResponseSchema
  }
  /**
   * Mutations
   *
   * @generated from rpc asset.v1.AssetService.UpdateAsset
   */
  updateAsset: {
    methodKind: 'unary'
    input: typeof UpdateAssetRequestSchema
    output: typeof UpdateAssetResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.UpdateAssets
   */
  updateAssets: {
    methodKind: 'unary'
    input: typeof UpdateAssetsRequestSchema
    output: typeof UpdateAssetsResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.ArchiveAsset
   */
  archiveAsset: {
    methodKind: 'unary'
    input: typeof ArchiveAssetRequestSchema
    output: typeof ArchiveAssetResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.ArchiveAssets
   */
  archiveAssets: {
    methodKind: 'unary'
    input: typeof ArchiveAssetsRequestSchema
    output: typeof ArchiveAssetsResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.RestoreAsset
   */
  restoreAsset: {
    methodKind: 'unary'
    input: typeof RestoreAssetRequestSchema
    output: typeof RestoreAssetResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.RestoreAssets
   */
  restoreAssets: {
    methodKind: 'unary'
    input: typeof RestoreAssetsRequestSchema
    output: typeof RestoreAssetsResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.DeleteAsset
   */
  deleteAsset: {
    methodKind: 'unary'
    input: typeof DeleteAssetRequestSchema
    output: typeof DeleteAssetResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.DeleteAssets
   */
  deleteAssets: {
    methodKind: 'unary'
    input: typeof DeleteAssetsRequestSchema
    output: typeof DeleteAssetsResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.MoveAssets
   */
  moveAssets: {
    methodKind: 'unary'
    input: typeof MoveAssetsRequestSchema
    output: typeof MoveAssetsResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.EmptyArchive
   */
  emptyArchive: {
    methodKind: 'unary'
    input: typeof EmptyArchiveRequestSchema
    output: typeof EmptyArchiveResponseSchema
  }
  /**
   * Queries
   *
   * @generated from rpc asset.v1.AssetService.GetAsset
   */
  getAsset: {
    methodKind: 'unary'
    input: typeof GetAssetRequestSchema
    output: typeof GetAssetResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.GetAssets
   */
  getAssets: {
    methodKind: 'unary'
    input: typeof GetAssetsRequestSchema
    output: typeof GetAssetsResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.GetAssetCategories
   */
  getAssetCategories: {
    methodKind: 'unary'
    input: typeof GetAssetCategoriesRequestSchema
    output: typeof GetAssetCategoriesResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.ListAssets
   */
  listAssets: {
    methodKind: 'unary'
    input: typeof ListAssetsRequestSchema
    output: typeof ListAssetsResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.CountAssets
   */
  countAssets: {
    methodKind: 'unary'
    input: typeof CountAssetsRequestSchema
    output: typeof CountAssetsResponseSchema
  }
  /**
   * Versions
   *
   * @generated from rpc asset.v1.AssetService.CreateVersion
   */
  createVersion: {
    methodKind: 'unary'
    input: typeof CreateVersionRequestSchema
    output: typeof CreateVersionResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.PublishVersion
   */
  publishVersion: {
    methodKind: 'unary'
    input: typeof PublishVersionRequestSchema
    output: typeof PublishVersionResponseSchema
  }
  /**
   * @generated from rpc asset.v1.AssetService.ListVersions
   */
  listVersions: {
    methodKind: 'unary'
    input: typeof ListVersionsRequestSchema
    output: typeof ListVersionsResponseSchema
  }
}> = /*@__PURE__*/ serviceDesc(file_asset_v1_asset, 0)
